import React from "react";
import { withTranslation } from 'react-i18next';
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";

import Footer from "../../Footer/FooterBottom";
import Backgrounds from "../../Admin/Question/View/Background";

import fileImg from "./file.png";
import examVideo from "./2.mp4";
import gameVideo from "./3.mp4";

class Registration extends React.Component {

    componentDidMount() {
        // window.scrollToPosition("register-section");
    }

    render() {
        const { t } = this.props;

        return (
            <>
                <Helmet>
                    <title>
                        {t('Pages.Register.title')}  | {t('alarabeyya')}
                    </title>
                </Helmet>
                <section className="pos-rel call-in-action call-overlay oh" id="register-section" style={{
                    backgroundColor: '#75cdff',
                    borderBottom: '1px solid #0e2c53',
                    backgroundAttachment: 'fixed',
                    minHeight: '100vh'
                }}>
                    <div className="position-relative padding-bottom pt-4" style={{
                        minHeight: '100vh'
                    }}>
                        <span className="d-none d-md-block">
                            <Backgrounds CustomBackground="Registration" />
                        </span>
                        <div className="container">
                            <div className="teacher-wrapper pos-rel pt-md-5 pt-sm-2 rounded main-bg">
                                <div className=" teacher-single-content px-1 d-flex flex-column pt-3">
                                    <h3 className="title text-center font-weight-bold h2">

                                        أَحصُل على 10 مِلفَّات مجَّانًا
                                    </h3>
                                    <div className="w-100 text-center mt-3 h5 p-3 rounded" style={{
                                        background: '#ffffff80'
                                    }}>
                                        <p className="text-justify">
                                            -
                                            صِفْر مَخاطِر : يُمْكِنك إِلغَاء الاشْتراك بِبضْع نَقَرات فِي أيِّ وَقْت تُريد خِلَال الشَّهْر الأوَّل ، ولن تَدفَع أيَّ شَيْء .
                                        </p>
                                        <p className="text-justify">
                                            -
                                            فِي حالٍ قَررَت الاسْتمْرار دُون إِلغَاء الحسَاب ، ستدْفع 10 $ لِلشَّهْر على الاشْتراك السَّنَويِّ .

                                        </p>
                                    </div>
                                    <div className="w-100 text-center mt-3 order-sm-2 order-md-3">
                                        <img src="https://elabib.com/UploadedFiles/Sliders/2021_5_23_19_30_36_38.PNG" alt="كتاب مفاتيح في الرياضيّات للصّفّين الأوّل والثاني" />
                                    </div>
                                    <div className="form-group w-100 text-center d-flex justify-content-around align-items-center mt-3 order-sm-3 order-md-2">
                                        <Link to="/Register" className={`custom-button`} >
                                            <span className="d-flex justify-content-center align-items-center flex-wrap">
                                                اِبْدأ تجْربَتك المجَّانيَّة الآن
                                                <i className="icon fad fa-arrow-left px-2"></i>
                                            </span>
                                        </Link>
                                    </div>
                                </div>
                            </div>

                            <div className="row clearfix justify-content-center mt-4">
                                <div className="featured-block col-lg-3 col-md-6 col-sm-12"  >
                                    <div className="inner-box wow fadeInLeft animated d-flex h-100 flex-column justify-content-around" data-wow-delay="0ms" data-wow-duration="1500ms" >
                                        <span className="border-one"></span>
                                        <span className="border-two"></span>
                                        <div className="icon-box d-flex justify-content-center flex-column ">
                                            <span className="icon"> <i className=" fa-light fa-download display-4 text-white"></i></span>
                                        </div>
                                        <h5 >
                                            تمَّ تَحمِيل 612,538 +


                                        </h5>
                                        <p className=" text-dark" style={{
                                            fontSize: '16px'
                                        }}  >
                                            قام مُسْتخْدمي هَيَّا إِلى العربيَّة بِتحْمِيل أَكثَر مِن 600 أَلْف مِلفٍّ


                                        </p>
                                    </div>
                                </div>

                                <div className="featured-block col-lg-3 col-md-6 col-sm-12"  >
                                    <div className="inner-box wow fadeInLeft animated d-flex h-100 flex-column justify-content-around" data-wow-delay="0ms" data-wow-duration="1500ms" >
                                        <span className="border-one"></span>
                                        <span className="border-two"></span>
                                        <div className="icon-box d-flex justify-content-center flex-column ">
                                            <span className="icon"> <i className=" fa-light fa-users display-4 text-white"></i></span>
                                        </div>
                                        <h5 >
                                            200 أَلْف مُستخدِم


                                        </h5>
                                        <p className=" text-dark" style={{
                                            fontSize: '16px'
                                        }}  >
                                            عدد مُسْتخْدمي المواقع التَّعْليميَّة التَّابعة لَنَا أَكثَر مِن 200 أَلْف مُستخدِم


                                        </p>
                                    </div>
                                </div>

                                <div className="featured-block col-lg-3 col-md-6 col-sm-12"  >
                                    <div className="inner-box wow fadeInLeft animated d-flex h-100 flex-column justify-content-around" data-wow-delay="0ms" data-wow-duration="1500ms" >
                                        <span className="border-one"></span>
                                        <span className="border-two"></span>
                                        <div className="icon-box d-flex justify-content-center flex-column ">
                                            <span className="icon"> <i className=" fa-light fa-globe display-4 text-white"></i></span>
                                        </div>
                                        <h5 >
                                            24 + دَولَة


                                        </h5>
                                        <p className=" text-dark" style={{
                                            fontSize: '16px'
                                        }}  >
                                            يُوجَد لَديْنَا زَبائِن بِأكْثر مِن 24 دَولَة حَوْل العالم


                                        </p>
                                    </div>
                                </div>

                                <div className="featured-block col-lg-3 col-md-6 col-sm-12"  >
                                    <div className="inner-box wow fadeInLeft animated d-flex h-100 flex-column justify-content-around" data-wow-delay="0ms" data-wow-duration="1500ms" >
                                        <span className="border-one"></span>
                                        <span className="border-two"></span>
                                        <div className="icon-box d-flex justify-content-center flex-column ">
                                            <span className="icon"> <i className=" fa-light fa-presentation-screen display-4 text-white"></i></span>
                                        </div>
                                        <h5 >
                                            2500 + مِلفٍّ


                                        </h5>
                                        <p className=" text-dark" style={{
                                            fontSize: '16px'
                                        }}  >
                                            سَتجِد أَكثَر مِن 2500 مِلفٍّ بِالْإضافة لِلْملفَّات اَلتِي نُضيفهَا بِشَكل شَهرِي

                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className="teacher-wrapper pos-rel mt-4 rounded pt-md-5 pt-sm-2" style={{
                                background: '#fff8eb'
                            }}>
                                <div className=" teacher-single-content p-3 ">
                                    <h3 className="title text-center">
                                        التَّجْربة المجَّانيَّة تَشمَل
                                    </h3>
                                    <h4 className="title mt-4 font-weight-bold mb-3 text-center">
                                        مُكَافأَة 1 # ( القيمة 259 $ )
                                    </h4>
                                    <h5 className="title text-center mb-3">
                                        " تَحمِيل 10 مِلفَّات مجَّانًا "
                                    </h5>
                                    <img src={fileImg} className="w-100" alt="img" />
                                    <div className="w-100 mt-3 h5">
                                        <p className="text-justify">
                                            <i className="fa-solid fa-circle-small mx-2"></i>
                                            مَوقِع هَيَّا إِلى العربيَّة يَحتَوِي على أَكثَر مِن

                                            <span className=" font-weight-bold mx-1">
                                                2500 مِلفٍّ
                                            </span>
                                            (
                                            أَورَاق عمل وامْتحانات


                                            )
                                            القابلة لِلتَّحْميل فِي
                                            <span className=" font-weight-bold mx-2">
                                                كَافَّة مَواضِيع اَللغَة العربيَّة
                                            </span>
                                            (كُلُّ مَوضُوع مُمْكِن أن يَخطُر على بَالِك لِلْمرْحلة الابْتدائيَّة والْمرْحلة الإعْداديَّة مَوجُود دَاخِل اَلموْقِع )  .
                                        </p>
                                        <p className="text-justify">
                                            <i className="fa-solid fa-circle-small mx-2"></i>
                                            طبْعًا مع الأخْذ بِالْحسْبان مَواضِيع مُنَاسبَة لِجميع الفئَات والْمجْتمعات .
                                        </p>
                                        <p className="font-weight-bold">
                                            بِاخْتصار ، بدل حَرْق ساعات مِن حَياتِك لِتجْهِيز وَظائِف وامْتحانات وأوْرَاق عمل مُمْكِن بِكلِّ بَساطَة تَحمِيل الملفَّات بِنقْرة زِرٍّ .
                                        </p>
                                    </div>



                                    <h4 className="title mt-5 font-weight-bold mb-3 text-center">
                                        مُكَافأَة 2 # مجَّانًا لِلْيوْم فقط ( القيمة 197 $ )
                                    </h4>
                                    <h5 className="title text-center mb-3">
                                        " فَتْح 3 أَلعَاب تعْليميَّة "


                                    </h5>
                                    <video muted loop className="w-100" controls autoPlay>
                                        <source src={examVideo} type="video/mp4" />
                                    </video>
                                    <div className="w-100 mt-3 h5">
                                        <p className="text-justify">
                                            <i className="fa-solid fa-circle-small mx-2"></i>
                                            مَوقِع هَيَّا إِلى العربيَّة يَحتَوِي على أَلعَاب تعْليميَّة

                                            (
                                            <span className=" font-weight-bold mx-1">
                                                قُمنَا بِبرْمجتهَا مِن الصِّفْر وغيْر مَوجُودة فِي أيِّ مَوقِع آخر
                                            </span>
                                            )
                                        </p>
                                        <p className="text-justify">
                                            <i className="fa-solid fa-circle-small mx-2"></i>

                                            هَذِه الألْعاب حَصرِية لِموْقع هَيَّا العربيَّة ، وَمِن سَابِع المسْتحيلات أن تَجدهَا بِأيِّ مَكَان آخر على الإنْترْنت ؛ والسَّبب بِكلِّ بَساطَة هُو أَننَا قد قُمنَا بِبنائهَا مِن العدم
                                            (اِبتِداء مِن الفكْرة وُصولا إِلى البرْمجة )
                                        </p>
                                        <p className="font-weight-bold">
                                            وُصُول مَوقِع هَيَّا إِلى العربيَّة لِلْمسْتوى اَلذِي هُو عليْه اليوْم اِحْتَاج مِنَّا أَكثَر مِن x سَنَوات عمل وأكْثر مِن x مِلْيون دُولار
                                        </p>
                                        <p className="text-justify">
                                            لِهَذا السَّبب مِن شِبْه المسْتحيل أن تَقُوم الشَّركات الصَّغيرة بِتقْلِيد اَلأُمور اَلتِي نُقَدمهَا .
                                        </p>
                                    </div>

                                    <h4 className="title mt-5 font-weight-bold mb-3 text-center ">
                                        مُكَافأَة 3 # مجَّانًا لِلْيوْم فقط ( القيمة 197 $ )
                                    </h4>
                                    <h5 className="title text-center mb-3">
                                        " فَتْح 3 مِلفَّات مُحَوسبَة "
                                    </h5>
                                    <video muted loop className="w-100" controls autoPlay>
                                        <source src={gameVideo} type="video/mp4" />
                                    </video>
                                    <div className="w-100 mt-3 h5">
                                        <p className="text-justify">
                                            <i className="fa-solid fa-circle-small mx-2"></i>
                                            الملفَّات المحوْسبة هِي اِمْتحانات وأوْرَاق عمل مُمْكِن حَلهَا عن طريق الكمْبيوتر ( الولد يَستطِيع أن يَتَعلَّم لِوحْده ، والْموْقع يَقُوم بِالتَّصْليح ؛ مِمَّا يُسَاعِد اَلمُعلم \ وَلِي الأمْر على اِختِصار الوقْتِ اَلذِي يحْتاجه لِفَحص الإجابات مِن عِدَّة ساعات إِلى عِدَّة ثَوَان )
                                            .
                                        </p>
                                        <p className="font-weight-bold">
                                            بِاخْتصار اَلموْقِع يَقُوم بِتقْدِيم قَائِمة تَحتَوِي على الإجابات الصَّحيحة والْإجابات الخاطئة بِالْإضافة لِعلامة الطَّالب بَعْد ثَوَان مِن إِنهَاء وَرقَة العمل أو الامْتحان المحوْسب .
                                        </p>
                                    </div>

                                    <h3 className="title text-center mt-4">
                                        القيمة اَلكُلية اَلتِي تَحصُل عليْهَا اليوْم بِالْمجَّان 653 $
                                    </h3>
                                </div>
                            </div>

                            <div className="teacher-wrapper pos-rel mt-4 rounded p-2 pt-md-3 pt-sm-2" style={{
                                background: '#fff8eb'
                            }}>
                                <h4 className="title font-weight-bold text-center pt-3">
                                    مَا هُو رَأْي المعلِّمين وأوْلياء اَلأُمور الَّذين يسْتخْدمون هَيَّا إِلى العربيَّة ؟
                                </h4>
                                <div className=" teacher-single-content">
                                    <div className="w-100 text-center mt-3 h5">
                                    </div>
                                </div>

                                <div className="w-100 py-1 bg-white my-4"></div>

                                <div className="about-content mb-3">
                                    <div className="faq-wrapper mb--10">
                                        <div className="faq-item">
                                            <div className="faq-title">
                                                <span className="right-icon"></span>
                                                <h5 className="title">
                                                    هل مُمْكِن إِرسَال مُهمَّات مُحَوسبَة لِلْأوْلاد ؟
                                                </h5>
                                            </div>
                                            <div className="faq-content" style={{ display: 'none' }}>
                                                <p className=" text-justify">
                                                    نعم مِن اَلممْكِن إِرسَال مَهَام مُحَوسبَة لِكلِّ طُلَّاب اَلصَّف أو لِجزْء مِن طُلَّاب اَلصَّف ، وَلكِن هَذِه الخاصِّيَّة مُتَوفرَة فقط بِاشْتراكات المدارس وليْس بِالاشْتراكات الفرْديَّة
                                                </p>
                                            </div>
                                        </div>

                                        <div className="faq-item">
                                            <div className="faq-title">
                                                <span className="right-icon"></span>
                                                <h5 className="title">
                                                    مَا الفرْق بَيْن الاشْتراكات الفرْديَّة وبيْن اِشْتراكات المدارس ؟
                                                </h5>
                                            </div>
                                            <div className="faq-content" style={{ display: 'none' }}>
                                                <p className=" text-justify">
                                                    اَلخُطة الفرْديَّة تَسمَح بِدخول شَخْص وَاحِد فقط لِلْموْقع أَمَّا بِاشْتراك المدارس يُمْكِنك فَتْح حِسَاب لِكلِّ طَاقِم اَللغَة العربيَّة وبالْإضافة لِذَلك يُمْكِنك تَحمِيل كُلِّ أَسمَاء الطُّلَّاب وفتْح حِسَاب مُنْفَرِد لِكلِّ طَالِب مِمَّا يُعْطِيك إِمْكانيَّة إِرسَال وَظائِف مُحَوسبَة بِشَكل مُبَاشِر لِلطُّلَّاب .
                                                </p>
                                            </div>
                                        </div>

                                        <div className="faq-item">
                                            <div className="faq-title">
                                                <span className="right-icon"></span>
                                                <h5 className="title">
                                                    هل يُوجَد مَوَاد مُلَاءمَة لِجميع المسْتويات ؟
                                                </h5>
                                            </div>
                                            <div className="faq-content" style={{ display: 'none' }}>
                                                <p className=" text-justify">
                                                    اَلموْقِع مُقسَّم حسب الصُّفوف كُلَّ صفٍّ يُوجَد لَديْه برْنامج مُنْفَرِد ( تَختَلِف اَلْمَواد حسب اَلصَّف )
                                                </p>
                                            </div>
                                        </div>

                                        <div className="faq-item">
                                            <div className="faq-title">
                                                <span className="right-icon"></span>
                                                <h5 className="title">
                                                    هل يَستطِيع أن يَدخُل عِدَّة مُعلِّمِين لِلْموْقع بِنَفس الوقْتِ مِن حِسَاب المدْرسة ؟

                                                </h5>
                                            </div>
                                            <div className="faq-content" style={{ display: 'none' }}>
                                                <p className=" text-justify">
                                                    طبْعًا كُلَّ مُعلِّم يَحصُل على اِسْم مُسْتخْدَم وَكلِمة مُرُور مُختلفَة مِمَّا يَعنِي أنَّ حِسَاب كُلِّ مُعلِّم يَكُون مُنْفصِلا بِشَكل تامٍّ عن بَاقِي المعلِّمين بِالْمدْرسة
                                                </p>
                                            </div>
                                        </div>

                                        <div className="faq-item">
                                            <div className="faq-title">
                                                <span className="right-icon"></span>
                                                <h5 className="title">
                                                    هل اَلموْقِع مُلَائِم لِدين مُعيَّن ؟
                                                </h5>
                                            </div>
                                            <div className="faq-content" style={{ display: 'none' }}>
                                                <p className=" text-justify">
                                                    اَلموْقِع مُلَائِم لِجميع الأدْيان وَلجمِيع فِئَات المجْتمع ( سَتجِد أُمُور مُلَاءمَة لَك بِغضِّ النَّظر عن دِينك )
                                                </p>
                                            </div>
                                        </div>

                                        <div className="faq-item">
                                            <div className="faq-title">
                                                <span className="right-icon"></span>
                                                <h5 className="title">
                                                    هل يُوجَد ضَمَان ( كَيْف أَتأَكد أنَّ اَلموْقِع مُنَاسِب لِاحْتياجاتي ) ؟


                                                </h5>
                                            </div>
                                            <div className="faq-content" style={{ display: 'none' }}>
                                                <p className=" text-justify">
                                                    بِكلِّ بَساطَة يُمْكِنك التَّسْجيل بِالتَّجْربة المجَّانيَّة وَتجرِبة اَلموْقِع بِنفْسك وَفِي حالٍ لَم تُحِب اَلموْقِع أو لَم تجدْه مُفيدًا يُمْكِنك إِلغَاء الاشْتراك بِبضْع نَقَرات بِأيِّ وَقْت خِلَال الشَّهْر الأوَّل ولن تَدفَع أيَّ شَيْء ( مع أنَّ هذَا الشَّيْء مِن عَاشِر المسْتحيلات ، لُوأن النَّاس لََا يسْتفيدون مِن اَلموْقِع لِمَا اِنتشَر بِشَكل جُنونيٍّ وَوصَل إِلى 24 دَولَة حَتَّى اللَّحْظة )
                                                </p>
                                            </div>
                                        </div>

                                        <div className="faq-item">
                                            <div className="faq-title">
                                                <span className="right-icon"></span><h5 className="title">
                                                    إِذَا لَم يُعْجبْني مَوقِع هَيَّا إِلى العربيَّة كَيْف أَقُوم بِإلْغَاء الاشْتراك ؟
                                                </h5>
                                            </div>
                                            <div className="faq-content" style={{ display: 'none' }}>
                                                <p className=" text-justify">
                                                    اشرح طريقة الغاء الإشتراك بالتفصيل
                                                </p>
                                                <ul>
                                                    <li className="text-justify"> <i className="far fa-dot-circle pr-3 dark-blue-text"></i>
                                                    </li>
                                                    <li className="text-justify"> <i className="far fa-dot-circle pr-3 dark-blue-text"></i>
                                                    </li>
                                                    <li className="text-justify"> <i className="far fa-dot-circle pr-3 dark-blue-text"></i>
                                                    </li>
                                                    <li className="text-justify"> <i className="far fa-dot-circle pr-3 dark-blue-text"></i>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="form-group w-100 text-center d-flex justify-content-around align-items-center  mt-4">
                                    <Link to="/Register" className={`custom-button`} >
                                        <span className="d-flex justify-content-center align-items-center flex-wrap">
                                            اِبْدأ تجْربَتك المجَّانيَّة الآن
                                            <i className="icon fad fa-arrow-left px-2"></i>
                                        </span>
                                    </Link>
                                </div>
                            </div>


                        </div>
                    </div>
                </section >
                <div className="position-sticky">
                    <Footer />
                </div>
            </>
        );
    }
}


export default withTranslation('common')(Registration);